module.exports = __webpack_public_path__ + "img/tertiary_1x1_z18.69240dce.svg";